import * as React from "react";

import "./per-ml.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";

import {AddressesSection} from "./addresses-section/addresses-section";
import {NamingSection}    from "./naming-section/naming-section";

export const PerMl = ({listIndex, entityId, next}) => cs(
    ["namingSection", (_, next) => NamingSection({listIndex, next})],
    ({namingSection}) => next({
        valid: namingSection.valid,
        highlightErrors: namingSection.highlightErrors,
        render: ({addresses, loading, countryCode, mlId, count, getAllMlIds}) => cs(
            keyed(listIndex),
            consumeContext("apis"),
            ["addressesSection", (_, next) => AddressesSection({addresses, entityId, next})],
            ({addressesSection, apis}) => (
                <div className="per-ml-360">
                    <div className="header">
                        <div className="left">
                            <div className="title">
                                Build Address List
                            </div>
                            <div className="sub-title" xd-qa-type="label" xd-qa-name="Subtitle Modal">
                                {loading ? (
                                    "Loading..."
                                ) : countryCode === "US" ? (
                                    `${addresses.value.filter((a) => a.status === "PASSED").length} records passed CASS and are mailable from a total of ${addresses.value.length} records`
                                ) : (
                                    `Total ${addresses.value.length} records (not verified by CASS)`
                                )}
                            </div>
                        </div>

                        <div className="right">
                            {addressesSection.searchInput}
                        </div>
                    </div>

                    <div className="addresses-section">
                        <div className="box">
                            {addressesSection.renderTable({
                                loading,
                                countryCode, mlId,
                            })}
                        </div>
                    </div>

                    {namingSection.render({
                        onApply: (naming) => apis.next.mailing.updateAlternateName({idList: mlId, alternateName: naming}),
                        onApplyAll: (naming) => Promise.all(getAllMlIds().map((idList) => (
                            apis.next.mailing.updateAlternateName({idList, alternateName: naming})
                        ))),
                        count,
                    })}
                </div>
            ),
        ),
    }),
);

